// TODO: This file will need to be refactored to resuse varaibles defined in enums or in other constants files and etc.
export const AGENCY_NAME: string = 'Agency';
export const CREATE_ANNUAL_IEP_MEETING: string = 'Create Annual IEP Meeting';
export const DELETE_ACTION: string = 'delete';
export const DOCUMENT_NAME: string = 'documentName';
export const EVENT_LOG: string = 'EventLog';
export const EDIT: string = 'edit';
export const EDIT_PARENT_OT_CHECKLIST: string = 'Edit Parent OT Checklist';
export const EDIT_PT_PARENT_CHECKLIST: string = 'Edit PT Parent Checklist';
export const EDIT_PT_TEACHER_CHECKLIST: string = 'Edit PT Teacher Checklist';
export const EDIT_TEACHER_OT_CHECKLIST: string = 'Edit Teacher OT Checklist';
export const EI_CIPS: number = 19;
export const EI_CONSENT_TRANSITION_CONFERENCE: number = 3;
export const EI_CUSTOM_OBSERVATION_ASSESSMENT: number = 22;
export const EI_FEEDING_ASSESSMENT: number = 23;
export const EI_PRESCHOOL_ACCEPTANCE_LETTER: number = 20;
export const EI_VISION_SCREENING_ASSESSMENT: number = 28;
export const EITRANSITION: string = 'eitransition';
export const FIRST_INDEX: number = 0;
export const INDEX_NOT_FOUND: number = -1;
export const INITIAL: string = 'initial';
export const LABEL_PRINCIPAL: string = 'PRINCIPAL';
export const LABEL_SCHOOL_SOCIAL_WORKERS: string =
  'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)';
export const LABEL_TEACHER: string = 'TEACHER';
export const LOCATION_CODE: string = 'locationCode';
export const LOCATION_KEY_INDEX: string = '0';
export const LOCATION_LENGTH: number = 1;
export const LOG_EVENT: string = 'Log Event';
export const NAVIGATION_DELAYS: number = 50;
export const PHYSICAL_EXAMINATION: string = 'Physical Examination';
export const RECONVENE_IEP_MEETING: string = 'Reconvene IEP Meeting';
export const REQUEST_FOR_ADDITIONAL_REEVALUATION: string =
  'Request for Additional Reevaluation';
export const REQUEST_FOR_REEVALUATION: string = 'Request for Reevaluation';
export const REVIEW_REQUEST_FOR_EXTENSION: string =
  'Review Request for Extension';
export const RESCHEDULE_IEP_MEETING: string = 'Reschedule IEP Meeting';
export const RESCHEDULE_SOCIAL_HISTORY_MEETING: string =
  'Reschedule Social History Meeting';
export const RE_UPLOAD: string = 'Re-Upload';
export const SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION: number = 1038;
export const SOCIAL_HISTORY_EVALUATION: string = 'Social History Evaluation';
export const SOCIAL_HISTORY_UPDATE: string = 'Social History Update';
export const STUDENT_NAME: string = 'studentName';
export const TITLE_PRINCIPAL: string = 'PRINCIPAL';
export const TITLE_SCHOOL_SOCIAL_WORKERS: string =
  'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)';
export const TITLE_TEACHER: string = 'TEACHER';
export const USER_ROLE_CSE_SCHOOL_PSYCHOLOGIST: number = 10;
export const VIEW: string = 'view';
export const VIEW_DECLASSIFICATION: string = 'View Declassification';
export const VIEW_IN_ELIGIBILITY: string = 'View InEligibility';
export const VIEW_NOTICE_OF_IEP_MEETING: string = 'View Notice of IEP Meeting';
export const VIEW_PARENT_OT_CHECKLIST: string = 'View Parent OT Checklist';
export const VIEW_PT_PARENT_CHECKLIST: string = 'View PT Parent Checklist';
export const VIEW_PT_TEACHER_CHECKLIST: string = 'View PT Teacher Checklist';
export const VIEW_TEACHER_OT_CHECKLIST: string = 'View Teacher OT Checklist';
export const VIEW_SOCIAL_HISTORY_MEETING: string =
  'View Social History Meeting';
